import BanksLogin from '../login/banks/BanksLogin';
import DealerLogin from '../login/DealerLogin';
import EmailLogin from '../login/EmailLogin';
import IdCardLogin from '../login/IdCardLogin';
import PasskeyLogin from '../login/PasskeyLogin';
import PersonalCodeLogin from '../login/PersonalCodeLogin';
import MobileIdLogin from '../login/pollable/MobileIdLogin';
import SmartIdLogin from '../login/pollable/SmartIdLogin';
import SmsLogin from '../login/SmsLogin';

export interface PanelType {
  authLevel: number;
  id: string;
  icon: string;
  component: () => React.JSX.Element;
  employee?: boolean;
}

export const Panels = (): PanelType[] => {
  return [
    {
      authLevel: 2,
      id: 'personal',
      icon: '#contact',
      component: PersonalCodeLogin,
    },
    {
      authLevel: 1,
      id: 'sms',
      icon: '#sms',
      component: SmsLogin,
    },
    {
      authLevel: 1,
      id: 'passkey',
      icon: '#fingerprint',
      component: PasskeyLogin,
    },
    {
      authLevel: 2,
      id: 'smartId',
      icon: '#smart-id',
      component: SmartIdLogin,
    },
    {
      authLevel: 2,
      id: 'mobileId',
      icon: '#mobiil-id',
      component: MobileIdLogin,
    },
    {
      authLevel: 2,
      id: 'idcard',
      icon: '#id',
      component: IdCardLogin,
    },
    {
      authLevel: 2,
      id: 'banks',
      icon: '#bank',
      component: BanksLogin,
    },
    {
      authLevel: 1,
      id: 'email',
      icon: '#email',
      component: EmailLogin,
    },
    {
      authLevel: -1,
      id: 'admin',
      icon: '#support',
      employee: true,
      component: DealerLogin,
    },
  ];
};
